import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

const supportedActions = [
  'GET_MEMBERS',
  'GET_NEW_MEMBERS',
  'GET_OLDER_MEMBERS',
  'CLEAR_MEMBERS',
];

export const consts = createReqConsts(
  'communities',
  'communityMembers',
  supportedActions,
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'communities',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['communityId'],
    },
    'members',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/communities/communityMembers.js